/**
 * CAOSLAB.DEV — CONTACT & LEAD CAPTURE MODULE
 * WhatsApp Direct CTA, Form validation, Service chips, and Confetti celebration.
 */

export function initContactModule() {
  const form = document.getElementById('lead-form');
  const serviceChips = document.querySelectorAll('.service-chip');
  const whatsappDirectBtn = document.getElementById('whatsapp-direct-btn');
  const floatingWhatsappBtn = document.getElementById('floating-whatsapp-btn');
  const serviceInput = document.getElementById('selected-service-input');
  const formSuccessBox = document.getElementById('form-success-box');
  const submitBtn = form?.querySelector('button[type="submit"]');

  const PHONE_NUMBER = "526278893344"; // +52 627 889 3344
  let selectedService = "Desarrollo Web";

  // Service chip selector
  serviceChips.forEach(chip => {
    chip.addEventListener('click', () => {
      serviceChips.forEach(c => c.classList.remove('selected'));
      chip.classList.add('selected');
      selectedService = chip.getAttribute('data-service') || "Desarrollo Web & IA";
      if (serviceInput) serviceInput.value = selectedService;
      updateWhatsAppLinks();
    });
  });

  function updateWhatsAppLinks() {
    const text = encodeURIComponent(`Hola CaosLab! Me interesa cotizar una solución de *${selectedService}* para transformar mi empresa y acelerar el crecimiento.`);
    const url = `https://wa.me/${PHONE_NUMBER}?text=${text}`;

    if (whatsappDirectBtn) {
      whatsappDirectBtn.href = url;
    }
    if (floatingWhatsappBtn) {
      floatingWhatsappBtn.href = url;
    }
  }

  // Initial WhatsApp links setup
  updateWhatsAppLinks();

  // Form submission handler
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const name = document.getElementById('form-name')?.value || '';
      const email = document.getElementById('form-email')?.value || '';
      const phone = document.getElementById('form-phone')?.value || 'No especificado';
      const message = document.getElementById('form-message')?.value || '';

      const originalBtnText = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = `
          <svg class="animate-spin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="display:inline-block; animation: spin 1s linear infinite;"><circle cx="12" cy="12" r="10" stroke-dasharray="32" stroke-linecap="round"/></svg>
          Registrando solicitud...
        `;
      }

      // 1. Save Lead to Cloud Firestore (Lazy-loaded)
      try {
        const { createContactLead } = await import('./firebase.js');
        await createContactLead({
          name,
          email,
          phone,
          service: selectedService,
          message
        });
      } catch (err) {
        console.warn("Could not save to Firestore (will proceed to WhatsApp):", err);
      }

      // 2. Trigger Confetti in metallic gold & purple colors (Lazy-loaded)
      try {
        const confettiModule = await import('canvas-confetti');
        const confetti = confettiModule.default || confettiModule;
        confetti({
          particleCount: 90,
          spread: 80,
          origin: { y: 0.6 },
          colors: ['#d4af37', '#f7e07d', '#3e0d62', '#8e24aa', '#ffffff']
        });
      } catch (err) {
        // Fallback silently if confetti cannot be loaded
      }

      // 3. Show success message
      if (formSuccessBox) {
        formSuccessBox.style.display = 'block';
      }
      form.reset();

      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalBtnText;
      }

      // 4. Redirect to WhatsApp with structured lead information
      setTimeout(() => {
        const customText = encodeURIComponent(
          `*Nuevo Lead CaosLab*\n` +
          `• *Nombre / Empresa:* ${name}\n` +
          `• *Email:* ${email}\n` +
          `• *Teléfono/WhatsApp:* ${phone}\n` +
          `• *Servicio de Interés:* ${selectedService}\n` +
          `• *Detalles:* ${message}`
        );
        window.open(`https://wa.me/${PHONE_NUMBER}?text=${customText}`, '_blank');
      }, 900);
    });
  }
}
